<template>
  <div>
    <div class="dropdown">
      <button
        class="btn btn-default dropdown-toggle"
        type="button"
        :id="`dropdown_filter_list-${referenceId}`"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="true"
      >
        {{ textDisplayed }}
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu student-view--filter-dropdown" :aria-labelledby="`dropdown_filter_list-${referenceId}`">
        <li v-for="(item, index) in itemsFilter" :key="index" class="checkbox">
          <label class="student-view__filter-checkbox-item">
            <input v-model="selectedItems" :value="item.value" type="checkbox"> {{ item.text }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    referenceId: {
      type: String,
      required: true,
    },
    itemsFilter: {
      type: Array,
      required: true,
    },
    textDisplayed: {
      type: String,
      required: true,
    },
    preSelectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedItems: null,
    };
  },
  mounted() {
    this.selectedItems = this.preSelectedItems;
  },
  watch: {
    selectedItems() {
      this.$emit('items-changed', this.selectedItems);
    },
  },
};
</script>
